import { Box, styled } from '@mui/material';

export const HeaderContainer = styled(Box)(({ theme }) => ({
  width: `calc(50% - ${theme.spacing(2)})`
}));
